import React, { useState, useEffect, Fragment } from 'react';
import axios from 'axios';

import { currentLanguage } from 'utils/currentLanguage';
import staticDataEN from 'data/staticTextEN';

export const StaticTextContext = React.createContext();

export const StaticTextProvider = ({ children }) => {
  const [labels, setLabels] = useState(null);

  useEffect(() => {
    axios
      .get('/' + currentLanguage + '/rest/ta/labels?_format=json')
      .then(({ status, data }) => {
        setLabels(status === 200 ? data : staticDataEN);
      })
      .catch((error) => {
        setLabels(staticDataEN);
      });
  }, []);

  return (
    <StaticTextContext.Provider
      value={{
        labels: labels,
      }}
    >
      {!!labels && (<Fragment>{children}</Fragment>)}
    </StaticTextContext.Provider>
  );
};



// WEBPACK FOOTER //
// ./src/context/StaticTextContext.js